import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import CommonPage from '../components/common-page/CommonPage';
import CommonTabs, { TABS_APPEARANCE } from '../components/common-tabs/CommonTabs';
import CommonTabPanel from '../components/common-tabs/CommonTabPanel';
import useActiv8Tabs from './hooks/useActiv8Tabs';
import Find from './find/Find';
import { changeActiv8Tab, resetParams } from '../redux/activ8/activ8Reducer';
import { ACTIV8_TABS } from '../constants';
import { clearCaches } from '../service/mediaCache';
import Studio from './studio/Studio';
import { getActiv8ProjectName } from '../redux/activ8/activ8Actions';
import useLeaveHandler from '../hooks/useLeaveHandler';
import { clearAllAiStudio } from '../redux/ai-studio/aiStudioActions';
import ContentUpdateController from './components/content-update-controller/ContentUpdateController';
import Messages from './messages/Messages';
import { resetStory, setAddMessageToStoryMode } from '../redux/story/storyReducer';
import { clearSession } from '../redux/activ8/activ8MessagesActions';
import { resetParams as resetActiv8MessagesParams } from '../redux/activ8/activ8MessagesReducer';
import Story from './story/Story';

function Activ8() {
  const dispatch = useDispatch();
  const { id: projectId } = useParams();

  const TABS = useActiv8Tabs();

  const activ8Tab = useSelector((state) => state.activ8.activ8Tab);

  const handleChangeTabs = (_, newTab) => {
    if (activ8Tab === ACTIV8_TABS.MESSAGES && newTab !== ACTIV8_TABS.MESSAGES) {
      dispatch(setAddMessageToStoryMode(false));
    }
    dispatch(changeActiv8Tab(newTab));
  };

  const handleClear = () => {
    dispatch(clearAllAiStudio());
    dispatch(resetParams());
    clearCaches();
    dispatch(resetStory());
    dispatch(clearSession());
    dispatch(resetActiv8MessagesParams());
  };

  useEffect(() => {
    dispatch(getActiv8ProjectName({ id: projectId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useLeaveHandler(handleClear);

  return (
    <CommonPage>
      <CommonTabs
        tabs={TABS}
        value={activ8Tab}
        onChange={handleChangeTabs}
        isFullWidth={true}
        isContainerFullWidth={true}
        appearance={TABS_APPEARANCE.OUTLINED}
      />

      <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.FIND}>
        <Find />
      </CommonTabPanel>

      <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.STUDIO}>
        <Studio />
      </CommonTabPanel>

      <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.MESSAGES}>
        <Messages />
      </CommonTabPanel>

      <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.STORY}>
        <Story />
      </CommonTabPanel>

      <ContentUpdateController />
    </CommonPage>
  );
}

export default Activ8;
